import { AlertService } from '@mapfre-design-library/src/public_api';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { Router } from '@angular/router';
import { ClientCredentialsTokenService } from '../_services/client-credentials/client-credentials-token.service';
import * as platform from 'platform';
import { AcmicService } from '@mapfre-design-library/src/public_api';
import { Capacitor } from '@capacitor/core';
import { DeviceInfoService } from '../_services/pwa-service/device-info.service';
import { LogoutService } from '@services/_iam/logout.service';
import { environment as ENV } from '@env/environment';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(
    private router: Router,
    private clientCredentialsTokenService: ClientCredentialsTokenService,
    private alertService: AlertService,
    private acmicService: AcmicService,
    private deviceInfoService: DeviceInfoService,
    private logoutService: LogoutService
  ) {}

  public intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // add authorization header with jwt token if available
    const deviceInfo = this.deviceInfoService.getDeviceInfo();
    const clientCredToken = this.clientCredentialsTokenService.getToken();
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    let companyNameFromSession: string;
    try {
      companyNameFromSession = sessionStorage.getItem('companyName');
    } catch {
      companyNameFromSession = 'MAPFRE';
    }
    const searchString = 'auth-client/oauth/token';
    const s3Url = 's3.amazonaws.com';
    const company = this.acmicService.isACMIC()
      ? 'AAA'
      : companyNameFromSession || 'MAPFRE';
    
    if (request.urlWithParams.search(searchString) == -1 && !request.url.includes(s3Url)) {
      
      if (currentUser && currentUser.access_token) {
        request = request.clone({
          setHeaders: {
            Authorization: `Bearer ${currentUser.access_token.access_token}`,
            id: currentUser.id.id,
            nonce: currentUser.id.nonce,
            name: currentUser.username,
            'x-access-token': localStorage.getItem('x-access-token'),
            company,
            platform: `${
              Capacitor.isNativePlatform()
                ? Capacitor.getPlatform()
                : Capacitor.getPlatform() + '|' + platform.description
            }|${deviceInfo}`,
          },
        });
      } else if (clientCredToken) {
        request = request.clone({
          setHeaders: {
            Authorization: `Bearer ${clientCredToken}`,
            platform: `${
              Capacitor.isNativePlatform()
                ? Capacitor.getPlatform()
                : Capacitor.getPlatform() + '|' + platform.description
            }|${deviceInfo}`,
            company,
          },
        });
      }
    }
    return next.handle(request).pipe(
      catchError((e) => {
        if (!e.url.includes('users/v2/authenticate') && e.status == '401' && !e.url.includes('/guest/')) {
            localStorage.clear();
            if (this.acmicService.isACMIC())
                window.location.href = `${ENV.OKTA.AAA.ISSUER}/oauth2/default/v1/logout?id_token_hint=${currentUser?.id.id}&post_logout_redirect_uri=${window.location.origin}`;
              else 
                window.location.href = `${ENV.OKTA.MAPFRE.ISSUER}/oauth2/default/v1/logout?id_token_hint=${currentUser?.id.id}&post_logout_redirect_uri=${window.location.origin}`;
            
        } else {
          return throwError(e);
        }
        return throwError(e);
      })
    );
  }
}
